import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import * as React from 'react'
import { Button, useNotify } from 'react-admin'
import { SendMultiVotes } from '.'
import Api from '../../../Apis/api.service'

export default function VerticalTabs(props) {
  const { id_var, refresh, record, isResolutionOpen } = props
  const [value, setValue] = React.useState(0)
  const [loading, setLoading] = React.useState(false)
  const notify = useNotify()

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const noVoteMessage = record.votes.length == 0 ? <p>Aucun vote</p> : null

  const onDelete = async (vote) => {
    if (vote.id === null) {
      return null
    }
    setLoading(true)
    const result = await Api.votes.delete(vote.id)

    const { data } = result
    setLoading(false)
    if (result.status !== 200) {
      notify(`Erreur: ${data.message}`, { type: 'warning' })
    } else if (data === 'OK') {
      notify('Succès')
      window['vote_modal_id'] = id_var
      refresh()
    } else {
      notify(`Erreur: ${data.message}`, { type: 'warning' })
    }
  }
  useEffect(() => {}, [record])
  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: 'background.paper',
        display: 'flex',
        height: 224,
      }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab label="Détail des votes" {...a11yProps(0)} />
        <Tab label="Saisir les votes" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        {noVoteMessage ? (
          noVoteMessage
        ) : (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Nom</TableCell>
                  <TableCell align="left">Vote</TableCell>
                  <TableCell align="left">Source</TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {record.votes.map((row) => (
                  <TableRow
                    key={row.libelle}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row" align="left">
                      {row.libelle}
                    </TableCell>
                    <TableCell align="left">{row.vote}</TableCell>
                    <TableCell align="left">{row.origin}</TableCell>
                    <TableCell align="left">
                      <Button
                        label="Effacer"
                        onClick={(e) => {
                          e.preventDefault()
                          onDelete(row)
                        }}
                        disabled={loading}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {/* {'RESOLUTIONS ==  SEND MULTI VOTES'} */}
        <SendMultiVotes
          key={record.id}
          record={props.ag}
          resolution={record}
          isResolutionOpen={isResolutionOpen}
          refresh={refresh}
        />
      </TabPanel>
    </Box>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  }
}
